import React from 'react'
import { FourGridIcon, NineGridIcon } from '../../Shared/SvgIcons'

import {
  NavigationBarContainer,
  NavigationBarContent,
  MenuItemWrapper
} from './styles'

export const ProfileNavigatorBar = (props) => {
  const {
    isMoreView,
    handleMoreView
  } = props

  return (
    <>
      <NavigationBarContainer>
        <NavigationBarContent>
          <MenuItemWrapper
            active
            onClick={() => handleMoreView()}
          >
            {isMoreView ? (
              <FourGridIcon />
            ) : (
              <NineGridIcon />
            )}
            <span>Items</span>
          </MenuItemWrapper>
        </NavigationBarContent>
      </NavigationBarContainer>
    </>
  )
}
